import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Drawer as DrawerType } from "melco-shared-logic";
import { FiltersMachineGroupsList } from "./FiltersMachineGroupsList";

export type AddMachineGroupsFilterDrawerProps = {
  machineGroupsFilterDrawer: DrawerType;
  machineGroupsFilter: any;
  setMachineGroupsFilter: any;
};
export const AddMachineGroupsFilterDrawer: React.FC<
  AddMachineGroupsFilterDrawerProps
> = ({
  machineGroupsFilterDrawer,
  machineGroupsFilter,
  setMachineGroupsFilter,
}) => {
  const { t } = useTranslation();
  const { isDrawerOpen, closeDrawer } = machineGroupsFilterDrawer;
  return (
    <>
      <Drawer
        open={isDrawerOpen}
        onClose={closeDrawer}
        closable={true}
        placement="right"
        title={t("reporting.statistics.filters.machineGroup.add.title")}
        width={1000}
      >
        <FiltersMachineGroupsList
          machineGroupsFilter={machineGroupsFilter}
          setMachineGroupsFilter={setMachineGroupsFilter}
        />
      </Drawer>
    </>
  );
};
